// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3ZGK1","colMin":"styles_colMin__xmOzP","colCheckbox":"styles_colCheckbox__T5F5M"};